<template>
  <div
    id="sticky-element"
    :class="{
      isMobile: $vuetify.breakpoint.mobile,
      removePadding: categories.length === 0,
    }"
    :style="{
      position: 'sticky',
      top: $vuetify.breakpoint.mobile ? '0px' : '63px',
      'z-index': $vuetify.breakpoint.mobile
        ? 2
        : $route.params.gameId && !$store.state.showDialogRegister
        ? 501
        : 202,
    }"
  >
    <div
      :style="{
        width: '100%',
        maxWidth: '1100px',
        padding: $vuetify.breakpoint.xs ? '4px 0px' : '4px 16px 3px',
        margin: '0px auto',
      }"
    >
      <div
        class="d-flex justify-start"
        :class="{ 'px-2': $vuetify.breakpoint.xs }"
      >
        <!-- Menu -->
        <v-chip
          v-if="$vuetify.breakpoint.xs"
          class="d-flex px-4 justify-center cursor-pointer flex-grow-1 flex-shrink-0"
          large
          outlined
          style="flex-basis: 5%"
          :style="
            $vuetify.breakpoint.mobile && {
              backgroundColor: 'var(--v-colorMainAppbg-base) !important',
              boxShadow: '0 0 10px rgba(0,0,0,0.5)',
            }
          "
          @click="openMenu()"
        >
          <v-icon left>mdi-menu</v-icon>
          <span>{{ $t("newCasino.categories") }}</span>
        </v-chip>
        <!-- Search -->
        <v-chip
          class="d-flex align-center justify-center cursor-pointer"
          :class="{
            'px-4 flex-grow-1 flex-shrink-0': !$vuetify.breakpoint.mobile,
            'mx-2': $vuetify.breakpoint.mobile,
          }"
          large
          outlined
          style="flex-basis: 15%"
          :style="
            $vuetify.breakpoint.mobile && {
              backgroundColor: 'var(--v-colorMainAppbg-base) !important',
              boxShadow: '0 0 10px rgba(0,0,0,0.5)',
            }
          "
          @click="$emit('openSearchDialog')"
        >
          <v-icon
            :left="!$vuetify.breakpoint.mobile"
            :center="$vuetify.breakpoint.mobile"
          >
            mdi-magnify
          </v-icon>
          <span v-show="!$vuetify.breakpoint.mobile">{{ $t("search") }}</span>
        </v-chip>
        <!-- Lobby only mobile -->
        <v-chip
          v-if="$vuetify.breakpoint.xs"
          class="d-flex px-4 justify-center cursor-pointer flex-grow-1 flex-shrink-0"
          :class="{ 'primary primary--text': activeButton({ name: 'Lobby' }) }"
          large
          outlined
          style="flex-basis: 5%"
          :style="
            $vuetify.breakpoint.mobile && {
              backgroundColor: 'var(--v-colorMainAppbg-base) !important',
              boxShadow: '0 0 10px rgba(0,0,0,0.5)',
            }
          "
          @click="changeCategory({ name: 'Lobby' })"
        >
          <v-icon left>{{ iconByTypeCasino[casinoType] }}</v-icon>
          <span>Lobby</span>
        </v-chip>
        <!-- divider -->
        <v-divider
          v-if="!$vuetify.breakpoint.xs"
          class="mr-3 ml-3 my-3"
          vertical
        ></v-divider>
        <!-- slide group -->
        <div
          v-if="!$vuetify.breakpoint.xs"
          class="overflow-hidden"
          :style="{ flexBasis: $vuetify.breakpoint.smAndUp ? '80%' : '58%' }"
        >
          <div class="menu-slider" style="padding: 1px 0">
            <v-slide-group :show-arrows="!$vuetify.breakpoint.xs">
              <template v-slot:prev>
                <v-hover v-slot="{ hover }">
                  <v-icon :color="hover ? 'primary' : ''" :size="32">
                    mdi-chevron-left
                  </v-icon>
                </v-hover>
              </template>
              <template v-slot:next>
                <v-hover v-slot="{ hover }">
                  <v-icon :color="hover ? 'primary' : ''" :size="32">
                    mdi-chevron-right
                  </v-icon>
                </v-hover>
              </template>
              <v-slide-item
                v-for="(category, index) in categories"
                :key="category.name"
                class="mr-2"
              >
                <v-chip
                  v-if="index > 0"
                  class="mr-1 px-6"
                  :class="{ 'primary primary--text': activeButton(category) }"
                  outlined
                  large
                  @click="changeCategory(category)"
                >
                  {{ category.name }}
                </v-chip>
              </v-slide-item>
            </v-slide-group>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "MenuCategories",
  props: ["categories", "searchDialog"],
  data: () => ({
    categorySelected: "",
    menu: true,
    iconByTypeCasino: {
      casino: "mdi-slot-machine-outline",
      live: "mdi-cards-club",
    },
  }),
  mounted() {
    window.addEventListener("scroll", this.setClassStickyElement);

    localStorage.setItem("previousType", "lobby");
  },
  watch: {
    $route(to, from) {
      const fromRouteName = from.name;
      const previousType =
        fromRouteName === "casinoCategory"
          ? "category"
          : fromRouteName === "casinoProviders"
          ? "providers"
          : fromRouteName === "casinoProvider"
          ? "provider"
          : "lobby";
      localStorage.setItem("previousType", previousType);
    },
  },
  computed: {
    casinoType() {
      return this.$route.params.casinoType;
    },
  },
  methods: {
    activeButton(category) {
      return category.name === "Lobby" && this.$route.name === "casinoLobby"
        ? true
        : category.name === this.$t("newCasino.providers") &&
          this.$route.name === "casinoProviders"
        ? true
        : this.$route.path.includes("providers") &&
          this.$route.params.providerId
        ? this.$route.params.providerId == category.id &&
          category.name !== "Search"
        : this.$route.params.category === category.name;
    },
    changeCategory(item) {
      if (item.name === this.$t("newCasino.providers")) {
        if (this.$route.name !== "casinoProviders") {
          this.$router.push({
            name: "casinoProviders",
            params: { casinoType: this.$route.params.casinoType },
            hash: "#scrollTop",
          });
        }

        return;
      }

      // Search
      if (item.name === "Search") {
        // Open search dialog
        this.$emit("openSearchDialog");
        return;
      }

      if (item.name === "Lobby") {
        if (this.$route.name !== "casinoLobby") {
          this.$router.push({
            name: "casinoLobby",
            params: { casinoType: this.$route.params.casinoType },
            hash: "#scrollTop",
          });
        }

        return;
      }

      if (this.$route.path.includes("providers")) {
        if (this.$route.params.providerId === item.id) {
          return;
        }

        this.$router.push({
          name: "casinoProvider",
          params: { providerId: item.id },
        });
      } else {
        if (this.$route.params.category === item.name) {
          return;
        }

        this.$router.push({
          name: "casinoCategory",
          params: { category: item.name },
        });
      }
    },
    openMenu() {
      // Abrir leftMenu - MenuCasino
      var menu = this.menu;
      this.$store.commit("setOpenMenu", menu);
    },
    setClassStickyElement() {
      var stickyElement = document.getElementById("sticky-element");
      var rect = stickyElement.getBoundingClientRect();
      var isMobile = window.innerWidth < 600;
      if (rect.top <= 63 && !isMobile) {
        stickyElement.classList.add("menuBlur");
      } else {
        stickyElement.classList.remove("menuBlur");
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.setClassStickyElement);
  },
};
</script>
<style scoped>
.menuBlur {
  position: relative;
  z-index: 3;
  background: rgba(0, 0, 0, 0.5) !important;
  backdrop-filter: blur(12.5px);
}

.menu-slider {
  overflow-x: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  scroll-behavior: smooth;
}
.isMobile.menu-slider::-webkit-scrollbar {
  display: none;
  width: 0px;
  background: transparent;
}
.removePadding >>> .v-toolbar__content {
  padding: 0 !important;
}
.menu-button >>> .v-btn__content {
  flex-direction: column;
  gap: 0.15rem;
}
</style>
